import { Injectable } from '@angular/core';
import { PscHttpService } from './psc-http.service';
import { Observable, tap } from 'rxjs';
import { Company } from '../common/models/company/company';
import { CompanyType } from '../common/models/company/company-type.enum';
import { PriceCountry } from '../common/models/price/price';
import { WarningBarService } from './warning-bar.service';

@Injectable({
  providedIn: 'root',
})
export class CompanyService {

  baseEndpoint = 'company/';

  constructor(
    private httpService: PscHttpService,
    private warningBarService: WarningBarService,
  ) {
  }


  getCompanies(type: CompanyType | '' = '', country: PriceCountry | '' = ''): Observable<Company[]> {
    return this.httpService.get(`${ this.baseEndpoint }?type=${ type }&country=${ country }`);
  }

  getCompany(id: string): Observable<Company> {
    return this.httpService.get(`${ this.baseEndpoint }${ id }`);
  }

  addCompany(company: Company, logo: File): Observable<Company> {
    const formData = new FormData();
    formData.append('logo', logo);
    formData.append('companyRequest', JSON.stringify(company));
    return this.httpService.post(`${ this.baseEndpoint }`, formData);
  }

  updateCompany(company: Company, logo: File): Observable<Company> {
    const formData = new FormData();
    formData.append('logo', logo);
    formData.append('companyRequest', JSON.stringify(company));
    return this.httpService.put(`${ this.baseEndpoint }`, formData);
  }

  deleteCompany(companyId: string) {
    return this.httpService.delete(`${ this.baseEndpoint }${ companyId }`);
  }

  getMyCompany(): Observable<Company> {
    return this.httpService.get(`${ this.baseEndpoint }owner/details`);
  }

  updateMyCompany(company: Company, logo: File): Observable<Company> {
    const formData = new FormData();
    formData.append('logo', logo);
    formData.append('companyRequest', JSON.stringify(company));
    return this.httpService.put(`${ this.baseEndpoint }owner/update`, formData).pipe(
      tap(() => this.warningBarService.checkWarnings()),
    );
  }

}
